module.exports = __webpack_public_path__ + "static/limoncello-c083b0d113fe6c611f1c2ce18e284f42.jpg";